import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container final-container">
        <div className="row justify-content-center final-content">
          <h1>REACT FINAL PROJECTS</h1>

          <div className="col-4">
            <div className="WeatherIcon">
              <img
                src="/weather-icon.png"
                className="weatherImage"
                alt="dictionary-logo"
              ></img>
            </div>
            <a
              className="weatherApp btn"
              href="https://stellar-melba-f7e52c.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              WEATHER
            </a>
          </div>
          <div className="col-4">
            <div className="DictionaryIcon">
              <img
                src="/dictionary-icon.png"
                className="dictionaryImage"
                alt="dictionary-logo"
              ></img>
            </div>
            <a
              className="dictionaryApp btn"
              href="https://roaring-crumble-3b6dd0.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              DICTIONARY
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
